module.exports = __webpack_public_path__ + "static/img/SULLIVAN-ROBEY.76c1f28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SULLIVAN-ROBEY.jpg
// module id = ba73
// module chunks = 0